import { createIcon } from '@chakra-ui/react';

export const Benefit2 = createIcon({
  displayName: `Benefit2`,
  viewBox: `0 0 64.831 51.992`,
  path: [
    <g key="1" transform="translate(32.5 0)">
      <path
        d="M480.065,921.963a6.191,6.191,0,0,1-5.858-4.189l-12.625-37.133a6.188,6.188,0,0,1,3.862-7.841l7.345-2.5a6.179,6.179,0,0,1,7.841,3.862L493.254,911.3a6.189,6.189,0,0,1-3.86,7.841h0l-7.345,2.5A6.138,6.138,0,0,1,480.065,921.963Zm-5.288-47.354a1.55,1.55,0,0,0-.5.08l-7.344,2.5a1.549,1.549,0,0,0-.965,1.963l12.624,37.131a1.551,1.551,0,0,0,1.963.965l7.344-2.5a1.551,1.551,0,0,0,.965-1.964l-5.06-14.883-7.564-22.25A1.548,1.548,0,0,0,474.777,874.609Z"
        transform="translate(-461.253 -869.971)"
        fill="currentColor"
      />
    </g>,
    <g key="2" transform="translate(15.71 0.206)">
      <path
        d="M464.322,921.686h-7.758a6.188,6.188,0,0,1-6.181-6.182V876.286a6.188,6.188,0,0,1,6.181-6.182h7.758a6.188,6.188,0,0,1,6.181,6.182V915.5A6.188,6.188,0,0,1,464.322,921.686Zm-7.758-46.948a1.549,1.549,0,0,0-1.546,1.548V915.5a1.548,1.548,0,0,0,1.546,1.548h7.758a1.549,1.549,0,0,0,1.546-1.548V876.286a1.55,1.55,0,0,0-1.546-1.548Z"
        transform="translate(-450.384 -870.104)"
        fill="currentColor"
      />
    </g>,
    <g key="3" transform="translate(0 0.206)">
      <path
        d="M454.152,921.686h-7.758a6.188,6.188,0,0,1-6.181-6.182V876.286a6.188,6.188,0,0,1,6.181-6.182h7.758a6.188,6.188,0,0,1,6.181,6.182V915.5A6.188,6.188,0,0,1,454.152,921.686Zm-7.758-46.948a1.549,1.549,0,0,0-1.546,1.548V915.5a1.548,1.548,0,0,0,1.546,1.548h7.758A1.548,1.548,0,0,0,455.7,915.5V876.286a1.549,1.549,0,0,0-1.546-1.548Z"
        transform="translate(-440.214 -870.104)"
        fill="currentColor"
      />
    </g>,
    <g key="4" transform="translate(42.064 11.639)">
      <g transform="translate(0 0)">
        <path
          d="M471.987,888.017a2.321,2.321,0,0,1-2.169-1.5l-2.223-5.879A2.317,2.317,0,1,1,471.928,879l2.224,5.878a2.318,2.318,0,0,1-1.347,2.989A2.35,2.35,0,0,1,471.987,888.017Z"
          transform="translate(-467.444 -877.505)"
          fill="currentColor"
        />
      </g>
    </g>,
    <g key="5" transform="translate(23.453 8.787)">
      <path
        d="M457.713,886.964a2.317,2.317,0,0,1-2.317-2.317v-6.67a2.317,2.317,0,1,1,4.634,0v6.67A2.317,2.317,0,0,1,457.713,886.964Z"
        transform="translate(-455.396 -875.659)"
        fill="currentColor"
      />
    </g>,
    <g key="6" transform="translate(7.742 8.787)">
      <path
        d="M447.543,886.964a2.317,2.317,0,0,1-2.317-2.317v-6.67a2.317,2.317,0,0,1,4.634,0v6.67A2.318,2.318,0,0,1,447.543,886.964Z"
        transform="translate(-445.226 -875.659)"
        fill="currentColor"
      />
    </g>,
  ],
});
